<template>
  <circular-slice
    class="circle-slice-right"
    :content-x="81.81"
    :content-y="48.4856"
    :content-width="16.22"
    :content-height="16.22"
    :show-notification="showNotification"
    :notification-position="'translate(50%,-50%)'"
    :locked="locked"
    :interaction-bus="interactionBus"
    :slice="'right'"
  >
    <template v-slot:accent-1
      ><div class="menu-slice-element menu-slice-accent-1"></div
    ></template>
    <template v-slot:accent-2
      ><div class="menu-slice-element menu-slice-accent-2"></div
    ></template>
    <template v-slot:body
      ><div class="menu-slice-element menu-slice-body"></div
    ></template>
    <template v-slot:fill>
      <div
        class="menu-slice-element menu-background"
        :style="{ '--menu-opacity': highlightOpacity }"
      ></div>
    </template>
    <template v-slot:highlight
      ><div class="menu-slice-element menu-slice-highlight"></div
    ></template>
    <template v-slot:icon>
      <div class="menu-slice-icon right-icon"></div
    ></template>
    <template v-slot:label>
      <span class="menu-slice-label">
        {{ $t("components.nav.circular_menu.menu_item_1") }}
      </span>
    </template>
  </circular-slice>
</template>

<script>
import CircularSlice from "@/components/nav/circular/CircularSlice";
import Vue from "vue";

export default {
  name: "CircularSliceRight",
  components: { CircularSlice },
  props: {
    locked: {
      type: Boolean,
      default: false
    },
    showNotification: {
      type: Boolean,
      default: false
    },
    interactionBus: {
      type: Vue,
      required: true
    },
    highlightOpacity: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style scoped>
.menu-slice-accent-1 {
  background-image: url("~@/assets/menu/menu-right-accent-1.svg");
}
.menu-slice-accent-2 {
  background-image: url("~@/assets/menu/menu-right-accent-2.svg");
}
.menu-slice-body {
  background-image: url("~@/assets/menu/menu-right-body.svg");
}
.menu-slice-highlight {
  background-image: url("~@/assets/menu/menu-right-c.svg");
}
.menu-background:before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: var(--menu-opacity);
  background-image: url("~@/assets/menu/menu-right-b.svg");
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
}

.right-icon {
  background-image: url("~@/assets/menu/menu-right-icon.svg");
}

.menu-slice-label {
  display: block;
  width: 6.2rem;
}

@media (min-width: 1024px) {
  .menu-slice-label {
    width: 7rem;
  }
}
</style>
